import { useState } from "react";
import {
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { AssignmentTurnedIn, TaskAlt, NoteAlt } from "@mui/icons-material";

const PickedStatusChip = ({ status, remarks }) => {
  const [open, setOpen] = useState(false);

  const config = {
    Assigned: {
      label: "Assigned",
      icon: <AssignmentTurnedIn />,
      bg: "#E3F2FD",
      color: "#1976D2",
    },
    Picked: {
      label: "Picked",
      icon: <TaskAlt />,
      bg: "#E8F5E9",
      color: "#2E7D32",
    },
    "Not Picked": {
      label: "Not Picked",
      icon: <NoteAlt />, // letterpad icon
      bg: "#FFF3CD",
      color: "#B26A00",
    },
  };

  const { label, icon, bg, color } = config[status];

  const handleChipClick = () => {
    if (status === "Not Picked") {
      setOpen(true);
    }
  };

  return (
    <>
      <Chip
        label={label}
        icon={icon}
        onClick={handleChipClick}
        sx={{
          backgroundColor: bg,
          color: color,
          fontWeight: "bold",
          borderRadius: "5px",
          cursor: status === "Not Picked" ? "pointer" : "default",
        }}
      />

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Remarks</DialogTitle>

        <DialogContent>
          <Typography variant="body1">
            {remarks || "No remarks available"}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PickedStatusChip;
